import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User deleted items',
  name: 'Deleted items',
  params: [
    {
      description: 'Item type',
      name: 'item_type',
      required: true,
      type: 'enum',
      values: ['library', 'asset', 'board'],
    },
    {
      description: 'Array of deleted item ids',
      name: 'item_ids',
      required: true,
      type: 'array',
      values: ['string'],
    },
    {
      description: 'Total number of deleted items',
      name: 'items_total',
      required: true,
      type: 'number',
    },
    {
      description: 'Location of the action',
      name: 'location',
      required: false,
      type: 'string',
    },
  ],
};

export default META;
